module.exports = __webpack_public_path__ + "img/lebanon.ca800d9b.png";